import { ReactNode } from "react";
import { Metadata, MetaProps } from "../metadata";
import { Inter } from "next/font/google";

const inter = Inter({ subsets: ["latin"] });

type Props = {
  readonly children?: ReactNode | ReactNode[];
  readonly meta: MetaProps;
};
export function Layout({ children, meta }: Props) {
  return (
    <>
      <Metadata {...meta} />
      <div style={{ width: "100vw" }} className={inter.className}>
        {children}
      </div>
    </>
  );
}
